import { useQuery } from '@tanstack/react-query';
import API_ENDPOINTS, { QUERY_KEYS } from 'services/urls';
import axiosInstance from 'ns_libs/nsAxios';

export interface DealLite {
    id: number;
    dealName: string;
    assetTypeCorrelationId?: string | null;
    description?: string | null;
}

interface UseGetOrganizationDealsLiteParams {
    orgId: string;
    enabled?: boolean;
}

const getOrganizationDealsLite = async (orgId: string): Promise<DealLite[]> => {
    const response = await axiosInstance.get(API_ENDPOINTS.DEALS_LITE(orgId));
    return response.data;
};

const useGetOrganizationDealsLite = ({
    orgId,
    enabled = true,
}: UseGetOrganizationDealsLiteParams) => useQuery({
    queryKey: [QUERY_KEYS.DEALS_LITE, orgId],
    queryFn: () => getOrganizationDealsLite(orgId),
    enabled,
});

export default useGetOrganizationDealsLite;
